import React, { useMemo } from 'react';
import './VideoSubscription.css';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../Utilities/useCart';

function VideoSubscription({ classData , classId }) {
  console.log('VideoSubscription classData:', classData, classId);
  const navigate = useNavigate();
  const { addToCart, isInCart } = useCart();

  // Generate Thumbnail Source
  const thumbnailSrc = useMemo(() => {
    if (!classData?.thumbnail) return '';
    const isBase64 = classData.thumbnail.length > 100 && /^[A-Za-z0-9+/=]+$/.test(classData.thumbnail);
    return isBase64 ? `data:image/jpeg;base64,${classData.thumbnail}` : classData.thumbnail;
  }, [classData?.thumbnail]);

  const handleAddToCart = () => {
    const cartItem = {
      id: classId,
      title: classData.title,
      instructor: classData.instructor,
      price: classData.cost,
      thumbnail: classData.thumbnail,
      education_class: classData.education_class,
      quantity: 1,
      type: 'subscription',
      class_uid: classId, 
    };

    if (!isInCart(classId)) {
      addToCart(cartItem);
    }

    navigate('/cart', { state: { classId: classId} });
  };

  return (
    <div className='video-subscription-container'>
      <div className='video-subscription-content'>
        <h3>Enjoyed the Intro? Unlock Full Access!</h3>
        <p>Subscribe to our video content and enjoy unlimited access to a wide range of educational videos.</p>
        <button
          className='subscribe-button'
          onClick={handleAddToCart}
        >
          {isInCart(classId) ? 'Go to Cart' : 'Subscribe Now'}
        </button>
      </div>
    </div>
  );
}

export default VideoSubscription;